import React, { useState, useEffect, useRef } from "react";
import "./cardparent.css";
import moment from "moment";

import Rating from "../../../../../components/RatingsModal/Rating";
import Subscription from "../../../../../components/Subscription/Subscription";
import { LoadingOutlined, StarFilled, StarOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import InterviewDrawer from "../../../../ProfileDetail/InterviewDrawer/interviewDrawer";
import { OfferModal } from "../../../../../components/OfferModal";
import { Button, Modal, Row } from "antd";
import {
  updateBid,
  updateInterview,
  editJobOffer,
  updateProposal,
} from "../../../../../redux/actions";
import AttachmentContainer from "./fileAttachment";
import FileDownloader from "./OfferCard/FileDownloader/FileDownloader";
import { RiCheckDoubleLine } from "react-icons/ri";
import DeleteRatingsModal from "./RatingsCard/component/deletRatingModal";

import history from "../../../../../routes/history";
import BillingExtendModal from "../../../../../components/BillingExtendModal";
import { log } from "@antv/g2plot/lib/utils";
import { Logger } from "aws-amplify";
import { LOG_TYPE } from "@aws-amplify/core/lib-esm/Logger";
import TextArea from "antd/lib/input/TextArea";
import { checkGapAPI } from "../../../../../API/API";

const CardParent = (props) => {
  const chatDetails = useSelector((state) => state.messagesReducer.chats);
  var editResponse = useSelector((state) => state.messagesReducer);
  const bidStatus = useSelector((state) => state.messagesReducer.bidStatus);
  const interviewLoading = useSelector(
    (state) => state.updateInterviewReducer.loading
  );
  const createInterviewLoading = useSelector(
    (state) => state.createInterviewReducer.loading
  );
  const updateBidLoading = useSelector(
    (state) => state.updateBidReducers.loading
  );
  
  const updateProposalLoading = useSelector(
    (state) => state.updateProposalReducers.loading
  );
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const dispatch = useDispatch();
  const inputA = useRef(null);
  const inputN = useRef(null);
  const inputAs = useRef(null);
  const inputAh = useRef(null);
  const [otherReason, setOtherReason] = useState('');
  const [declineReason, setDeclineReason] = useState('');
  const [submitReasonClicked, setSubmitReasonClicked] = useState(false);
  const [disableReasonCheck, setDisableReasonCheck] = useState(true);
  const { OfferCards, source, data } = props;
  //HOOKS****************
  const [scheduledTimings, setScheduledTimings] = useState(false);
  const [interviewDrawer, setinterviewDrawer] = useState(false);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [editOffer, setEditOffer] = useState();
  const [disabled, setDisabled] = useState(false);
  const [reScheduleInterviewHook, setReScheduleInterviewHook] = useState(false);
  const [editScheduleInterviewHook, setEditScheduleInterviewHook] =
    useState(false);
  const [bidId, setBidId] = useState(false);
  const [rejectCandidate, setRejectCandidate] = useState(false);
  const [bidType, setBidType] = useState(false);
  const [interviewId, setInterviewId] = useState(false);
  const [SkillListing_id, setSkillListing_id] = useState();
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [rejectReason, setRejectReason] = useState(false);
  const [modalText, setModalText] = useState();
  const [modalTitle, setModalTitle] = useState();
  const [modalText1, setModalText1] = useState();
  const [modalText2, setModalText2] = useState();
  const [modalText3, setModalText3] = useState();

  const [ratingModal, setRatingModal] = useState(false);
  const [gapExist, setGapExist] = useState()
  const [deleteRatingPop, setDeleteRatingPop] = useState(false);
  const [subscription, setSubs] = useState(false);
  const [offerCard, setOfferCard] = useState({});
  const [recipientUser, setRecipientUser] = useState({});
  const [ratings, setRatings] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [extendBilling, setExtendBilling] = useState(false);
  const [offerLoading, setOfferLoading] = useState(false);
  
  useEffect(() => {
    if (chatDetails.data?.body) {
      setBidId(chatDetails.data?.body[0]?.SecondarySourceId);
      setBidType(chatDetails.data?.body[0]?.SourceTypeId);

      chatDetails.data?.body.map((card) => {
        if (card?.Status == "Proposed Interview") {
          setScheduledTimings(card.InterviewCard?.Interviews_ScheduledTimings);
        } else if (
          // card?.Status == "Offer Accepted" ||
          card?.Status == "Offer Pending" ||
          card?.Status == "On Billing"
        ) {
          setOfferCard(card?.BidCard?.offers);
        } else {
          setRecipientUser(card?.RecipientUser);
          setRatings(card?.Ratings);
        }
      });
      setSkillListing_id(
        chatDetails.data?.body[0]?.SkillListingCard?.SkillListingId
      );
    }
  }, [chatDetails?.data?.body]);

  useEffect(() => {
    if (interviewId) {
      return;
    } else {
      setInterviewId(props.interviewCardID);
    }
  }, [props]);

  const disableHandler = () => {
    let array = bidStatus;
    let filteredArray = array.filter(
      (value) => value !== null && value !== undefined
    );
    if (filteredArray.length - props.index == filteredArray.length - 1) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(()=>{
    if(otherReason?.length>0 || inputA?.current?.value != null){
      setDisableReasonCheck(false);
    }
    else{
      setDisableReasonCheck(true);
    }
  },[otherReason,inputA])
  const scheduleInterview = () => {
    setinterviewDrawer(true);
  };

  const reScheduleInterview = () => {
    setReScheduleInterviewHook(true);
    setinterviewDrawer(true);
  };

  const editInterview = () => {
    setEditScheduleInterviewHook(true);
    setinterviewDrawer(true);
  };

  const MakeOffer = (action) => {
    setOpenOfferModal(true);
    if (action === "edit") {
      // if (editResponse._id) {
      //    setEditOffer(editResponse)
      // }
      setEditOffer(props.OfferCards);
    }
    // if(action==='post'){
    //    setEditOffer('edit')
    // }
  };

  const RejectCandidate = (status) => {
    if (status == "cancel") {
      dispatch(
        updateBid({
          id: bidId,
          BidStatusName: "Canceled",
          SkillListingId: SkillListing_id,
          loading: true,
        })
      );
    } else if (status == "rejected") {
      setRejectCandidate(true);
      setRejectModalVisible(true);
      setModalTitle("Decline this candidate?");
      setModalText("Please select a reason for declining this candidate:");
    } else if (status == "terminated") {
      dispatch(
        updateBid({
          id: bidId,
          BidStatusName: "Terminated",
          SkillListingId: SkillListing_id,
          loading: true,
        })
      );
    } else if (status == "interview cancelled") {
      setModalText("Please select a reason for cancelling this interview:");
      setModalTitle("Cancel this interview?");
      setModalText1("");
      setModalText2("");
      setModalText3("");
      setRejectModalVisible(true);
    } else if (status == "terminate") {
      dispatch(
        updateBid({
          id: bidId,
          BidStatusName: "Terminated",
          SkillListingId: SkillListing_id,
          loading: true,
        })
      );
    } else if (status === "Off Billing") {
      dispatch(
        updateBid({
          id: bidId,
          BidStatusName: "Off Billing",
          SkillListingId: SkillListing_id,
          loading: true,
        })
      );
    }
  };

  function rejectModalClose(params) {
    setRejectModalVisible(false);
  }

  const ratingHandler = () => {
    history.push({
      pathname: "/ratings",
      state: {
        bidId: chatDetails.data?.body[0]?.SecondarySourceId, //before bid id was here
        image: recipientUser?.Profiles?.PictureUrl,
        candidate_name: `${recipientUser?.Profiles?.FirstName} ${recipientUser?.Profiles?.LastName}`,
        Reviewee: chatDetails.data?.body[0]?.RecipientUser?.AccountId, //recipientUser?.AccountId
        skill_listing_title: chatDetails.data?.body[0]?.SkillListingCard?.Title,
        job_title: props.jobDetails?.Title,
        date_from: OfferCards?.FromDate,
        date_to: OfferCards?.ToDate,
        rating: false,
        previousScreen: "Messages",
        isEdit: false,
        conversationId: props.data.ConversationId,
        Reviewee:
          chatDetails?.data?.body[0]?.SourceTypeId == 1
            ? chatDetails?.data?.body[0]?.RecipientUser?.AccountId
            : chatDetails?.data?.body[0]?.SenderUser?.AccountId,
        SourceTypeId: chatDetails?.data?.body[0]?.SourceTypeId,
      },
    });

    setRatingModal(true);
  };
  const editRatingHandler = () => {
    history.push({
      pathname: "/ratings",
      state: {
        bidId: chatDetails.data?.body[0]?.SecondarySourceId,
        image: recipientUser?.Profiles?.PictureUrl,
        candidate_name: `${recipientUser?.Profiles.FirstName} ${recipientUser?.Profiles.LastName}`,
        skill_listing_title: chatDetails.data?.body[0]?.SkillListingCard?.Title,
        job_title: props?.data?.GigCard?.Title,
        date_from: offerCard?.FromDate,
        date_to: offerCard?.ToDate,
        rating: ratings,
        previousScreen: "Messages",
        isEdit: true,
        conversationId: props.data.ConversationId,
        Reviewee:
          chatDetails.data?.body[0]?.SourceTypeId == 1
            ? chatDetails.data?.body[0]?.RecipientUser?.AccountId
            : chatDetails.data?.body[0]?.SenderUser?.AccountId,
        SourceTypeId: chatDetails.data?.body[0]?.SourceTypeId,
      },
    });

    // setIsEdit((prevState) => !prevState)
    // setRatingModal(true);
  };

  const subsHandler = () => {
    setSubs(true);
  };

  const RejectModal = ({ text, title }) => {
    return (
      <>
        <Rating
          modal={ratingModal}
          bidId={bidId}
          setModal={setRatingModal}
          image={recipientUser?.Profiles?.PictureUrl}
          candidate_name={recipientUser?.UserName}
          skill_listing_title={
            chatDetails.data?.body[0]?.SkillListingCard?.Title
          }
          job_title={chatDetails.data?.body[0]?.GigCard?.Title}
          date_from={offerCard?.FromDate}
          date_to={offerCard?.ToDate}
          ratings={ratings}
          isEdit={isEdit}
        />

        <Modal
          title={title}
          onCancel={rejectModalClose}
          visible={rejectModalVisible}
          footer={null}
        >
          <div>{text}</div>
          <div
            ref={inputA}
            className="reject-modal-div"
            data-id="Accepted another candidate"
            onClick={(e) => {
              inputA.current.value = 1;
              setDisabled(true);
              inputA.current.style.backgroundColor = "#e4ffec";
              inputN.current.style.backgroundColor = "white";
              inputAs.current.style.backgroundColor = "white";
              // setRejectReason(e.target.getAttribute("data-id"));
              setOtherReason('');

            }}
          >
            Accepted another candidate
          </div>
          <div
            ref={inputN}
            className="reject-modal-div"
            data-id="Not Interested in the candidate"
            onClick={(e) => {
              inputA.current.value = 2;
              setDisabled(true);
              inputA.current.style.backgroundColor = "white";
              inputN.current.style.backgroundColor = "#e4ffec";
              inputAs.current.style.backgroundColor = "white";
              // setRejectReason(e.target.getAttribute("data-id"));
              setOtherReason('');
            }}
          >
            Not interested in the candidate
          </div>
          <div
            ref={inputAs}
            className="reject-modal-div"
            data-id="Asking Payrate is too high"
            onClick={(e) => {
              inputA.current.value = 4;
              setDisabled(true);
              inputA.current.style.backgroundColor = "white";
              inputN.current.style.backgroundColor = "white";
              inputAs.current.style.backgroundColor = "#e4ffec";
              // setRejectReason(e.target.getAttribute("data-id"));
              setOtherReason('');
            }}
          >
            Asking payrate is too high
          </div>
          <div
            ref={inputAs}
            className="reject-modal-div"
            data-id="other"
            // onClick={(e) => {
            //   inputA.current.value = 4;
            //   setDisabled(true);
            //   inputA.current.style.backgroundColor = "white";
            //   inputN.current.style.backgroundColor = "white";
            //   inputAs.current.style.backgroundColor = "#e4ffec";
            //   // setRejectReason(e.target.getAttribute("data-id"));
            // }}
          >
            Other
            <TextArea
              showCount
              maxLength={100}
              style={{
                height: 120,
                resize: 'none',
              }}
              onChange={(e)=>setOtherReason(e?.target?.value?.trim())}
              placeholder="disable resize"
              value={otherReason}
            />
          </div>
          <Button
            className="rejectModalBtn"
            // disabled={inputA?.current?.value == null}
            disabled={updateBidLoading && rejectCandidate}
            // disabled={!disabled}
            // disabled={updateBidLoading && rejectCandidate}
            onClick={() => {
              // setRejectReason();
              setRejectModalVisible(false);

              if (title == "Cancel this interview?") {
                dispatch(
                  updateInterview({
                    InterviewId: interviewId,
                    InterviewStatus: "Rejected",
                    type: "emp",
                    reschedule: true,
                    ReasonId: inputA.current.value,
                    loading: "Cancel-parent",
                  })
                );
              } else if (bidType == 2) {
                dispatch(
                  updateProposal({
                    id: bidId,
                    status: "Declined",
                    DeclineReasonId: inputA.current.value,
                  })
                );
              } else {
                // return;
                dispatch(
                  updateBid({
                    id: bidId,
                    BidStatusName: "Declined",
                    SkillListingId: SkillListing_id,
                    DeclineReasonId: inputA.current.value,
                    loading: true,
                  })
                );
              }
            }}
          >
            {updateBidLoading && rejectCandidate ? (
              <LoadingOutlined />
            ) : (
              "Submit Reason"
            )}
          </Button>
        </Modal>
      </>
    );
  };

  const DeleteRatingHandler = () => {
    setDeleteRatingPop(true);
  };

  const handleExtendContract = async()=>{
    setExtendBilling(true);
    try {
      const res = await checkGapAPI({BidId:bidId,BidType: source == 1 ? "Bid" : "Proposal"})
      setGapExist(res?.data?.gapExists)
    }catch(error){
      console.log('error', error)
    }
  }

  function HyperlinkParagraph({ text }) {
    const tokens = text?.split(/[\r\n\s]+/);
    const separators = text?.match(/[\r\n]+|[\s]+/g);
    let output = "";

    for (let i = 0; i < tokens?.length; i++) {
      //text email regex
      if (/(\S+@\S+\.\S+)/g.test(tokens[i])) {
        output += `<a key=${i} href=mailto:${tokens[i]}>${tokens[i]}</a>`;
      }
      //test link regex
      else if (/((https?:\/\/[^\s]+))/g.test(tokens[i])) {
        output += `<a rel="noopener noreferrer" target="_blank" href=${tokens[i]}>${tokens[i]}</a>`;
      } else output += tokens[i];
      if (i < separators?.length) {
        // console.log(separators[i],"seperator");
        // if (/\n/.test(separators[i]) || /\r/.test(separators[i])) {
        //   output += "<br/>"
        // } else if (/(\r\n|\n|\r|[ ]{2})/.test(separators[i])) {
        //   output += "<br/>"
        // } else if (/[ ]{2}/.test(separators[i])) {
        //   output += "<br/>"
        // } else
        output += separators[i];
      }
    }
    return (
      <div
        style={{ whiteSpace: "pre-line" }}
        dangerouslySetInnerHTML={{ __html: output }}
      ></div>
    );
  }

  useEffect(()=>{
    if(otherReason?.length>0){
      if(modalTitle == 'Decline this candidate?'){
        inputA.current.value = null;
        inputAh.current.value = null;
        inputA.current.style.backgroundColor = "white";
        inputAh.current.style.backgroundColor = "white";

      }
      // inputA.current.value = 0;
      // inputN.current.value = 0;
      // inputAh.current.value = 0;
      // inputAs.current.value = 0;
      inputA.current.style.backgroundColor = "white";
      // inputN.current.style.backgroundColor = "white";
      // inputAs.current.style.backgroundColor = "white";
      // inputAh.current.style.backgroundColor = "white";
      console.log('other/decline !!!!!!!!!!!!!!')
      setDeclineReason('');
    }
  },[otherReason])
  
  return (
    <>
      <InterviewDrawer
        reSchedule={reScheduleInterviewHook}
        interviewId={interviewId}
        bid={chatDetails?.data?.body[0]?.SecondarySourceId}
        timings={scheduledTimings}
        editScheduleInterviewHook={editScheduleInterviewHook}
        open={interviewDrawer}
        close={setinterviewDrawer}
        bidType={bidType}
      />
      {/* <RejectModal text={modalText} title={modalTitle} /> */}
      <Rating
        modal={ratingModal}
        bidId={bidId}
        setModal={setRatingModal}
        image={recipientUser?.Profiles?.PictureUrl}
        candidate_name={recipientUser?.UserName}
        skill_listing_title={chatDetails.data?.body[0]?.SkillListingCard?.Title}
        job_title={chatDetails.data?.body[0]?.GigCard?.Title}
        date_from={offerCard?.FromDate}
        date_to={offerCard?.ToDate}
        ratings={ratings}
        isEdit={isEdit}
      />
      <Modal
        title={modalTitle}
        onCancel={rejectModalClose}
        visible={rejectModalVisible}
        footer={null}
      >
        <div style={{color: disableReasonCheck && submitReasonClicked ? '#DB2828' : '#3E3E3E'}}>{modalText}</div>
        {modalTitle == 'Decline this candidate?' 
          ? 
            <>
              <div
          ref={inputA}
          className="reject-modal-div"
          data-id="Accepted another candidate"
          onClick={(e) => {
            inputA.current.value = 1;
            setDeclineReason('Accepted another candidate')
            setDisabled(true);
            inputA.current.style.backgroundColor = "#e4ffec";
            inputAh.current.style.backgroundColor = "white";
            // inputN.current.style.backgroundColor = "white";
            // inputAs.current.style.backgroundColor = "white";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false);
            setOtherReason('');
          }}
        >
          Accepted another candidate
        </div>
        {/* <div
          ref={inputN}
          className="reject-modal-div"
          data-id="Skills not a match"
          onClick={(e) => {
            inputA.current.value = 2;
            setDeclineReason('Skills not a match')
            setDisabled(true);
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "#e4ffec";
            inputAs.current.style.backgroundColor = "white";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false)
            setOtherReason('');
          }}
        >
          Skills not a match
        </div> */}
        <div
          ref={inputAh}
          className="reject-modal-div"
          data-id="Asking Payrate is too high"
          onClick={(e) => {
            inputA.current.value = 4;
            setDeclineReason('Asking payrate is too high')
            setDisabled(true);
            inputA.current.style.backgroundColor = "white";
            // inputN.current.style.backgroundColor = "white";
            inputAh.current.style.backgroundColor = "#e4ffec";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false);
            setOtherReason('');
          }}
        >
          Asking payrate is too high
        </div>
            </> 
          : 
            modalTitle == "Cancel this interview?"
            ?
              <>
              <div
          ref={inputA}
          className="reject-modal-div"
          data-id="Accepted another candidate"
          onClick={(e) => {
            inputA.current.value = 1;
            setDeclineReason('Accepted another candidate')
            setDisabled(true);
            inputA.current.style.backgroundColor = "#e4ffec";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "white";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false);
            setOtherReason('');
          }}
        >
          Accepted another candidate
        </div>
        <div
          ref={inputN}
          className="reject-modal-div"
          data-id="Asking payrate is too high"
          onClick={(e) => {
            inputA.current.value = 2;
            setDeclineReason('Asking payrate is too high')
            setDisabled(true);
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "#e4ffec";
            inputAs.current.style.backgroundColor = "white";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false)
            setOtherReason('');
          }}
        >
          Asking payrate is too high
        </div>
        <div
          ref={inputAs}
          className="reject-modal-div"
          data-id="Candidate is not responding"
          onClick={(e) => {
            inputA.current.value = 4;
            setDeclineReason('Candidate is not responding')
            setDisabled(true);
            inputA.current.style.backgroundColor = "white";
            inputN.current.style.backgroundColor = "white";
            inputAs.current.style.backgroundColor = "#e4ffec";
            // setRejectReason(e.target.getAttribute("data-id"));
            setDisableReasonCheck(false);
            setOtherReason('');
          }}
        >
          Candidate is not responding
        </div>
              </>
            :null
        }
        <div
            className="other-div"
            // onClick={(e) => {
            //   inputA.current.value = 4;
            //   setDisabled(true);
            //   inputA.current.style.backgroundColor = "white";
            //   inputN.current.style.backgroundColor = "white";
            //   inputAs.current.style.backgroundColor = "#e4ffec";
            //   // setRejectReason(e.target.getAttribute("data-id"));
            // }}
          >
           <h4>Other</h4>
            <div
              // ref={inputAs}
              // className="reject-modal-div"
              data-id="other"
            >
              <TextArea
                showCount
                maxLength={50}
                className="otherReasonInput"
                style={{
                  height: 80,
                  resize: 'none',
                  border: 'solid 1px #d4d4d4',
                  borderRadius: '4px',
                }}
                onChange={(e)=>setOtherReason(e?.target?.value)}
                placeholder="Please mention the reason"
                value={otherReason}
              />
            </div>
          </div>
        <Button
          className={"rejectModalBtn"}
          // disabled={(inputA?.current?.value == undefined ||inputA?.current?.value == null) && otherReason?.length<1}
          // disabled={disableReasonCheck}
          // disabled={updateBidLoading && rejectCandidate}
          onClick={() => {
            // setRejectReason();
            if(otherReason?.length<1 && declineReason?.length<1){
              setSubmitReasonClicked(true);
              return;
            }
            else if (modalTitle == "Cancel this interview?") {
              if(otherReason?.length>0){
                dispatch(
                  updateInterview({
                    InterviewId: interviewId,
                    InterviewStatus: "Rejected",
                    type: "emp",
                    reschedule: true,
                    ReasonId: 10,
                    DeclineReason: otherReason,
                    loading: "Cancel-parent",
                  })
                );
              }
              else{
                dispatch(
                  updateInterview({
                    InterviewId: interviewId,
                    InterviewStatus: "Rejected",
                    type: "emp",
                    reschedule: true,
                    ReasonId: 10,
                    DeclineReason: declineReason,
                    loading: "Cancel-parent",
                  })
                );
              }
              
            } else if (bidType == 2) {
              if(otherReason?.length>0){
                dispatch(
                  updateProposal({
                    id: bidId,
                    status: "Declined",
                    DeclineReasonId: 10,
                    DeclineReason: otherReason,
                    loading: true,
                  })
                );
              }
              else{
                dispatch(
                  updateProposal({
                    id: bidId,
                    status: "Declined",
                    DeclineReasonId: inputA.current.value,
                    loading: true,
                  })
                );
              }
            } else if(otherReason?.length>0) {
              dispatch(
                updateBid({
                  id: bidId,
                  BidStatusName: "Declined",
                  SkillListingId: SkillListing_id,
                  DeclineReasonId: 10,
                  DeclineReason: otherReason,
                  loading: true,
                })
              )
            }
            else{
              // dispatch(
              //   updateBid({
              //     id: bidId,
              //     BidStatusName: "Declined",
              //     SkillListingId: SkillListing_id,
              //     DeclineReasonId: inputA.current.value,
              //     loading: true,
              //   }))
                
                dispatch(
                updateBid({
                  id: bidId,
                  BidStatusName: "Declined",
                  SkillListingId: SkillListing_id,
                  DeclineReasonId: 10,
                  DeclineReason: declineReason,
                  loading: true,
                }))
            }
            setRejectModalVisible(false);

                
          }}
        >
          {updateBidLoading && rejectCandidate ? (
            <LoadingOutlined />
          ) : (
            "Submit Reason"
          )}
        </Button>
      </Modal>
      <DeleteRatingsModal
        visible={deleteRatingPop}
        Ratings_data={props.Ratings_data}
        setDelModalVisible={setDeleteRatingPop}
      />
      {openOfferModal && (
        <OfferModal
          visible={openOfferModal}
          setOpenOfferModal={setOpenOfferModal}
          bidID={chatDetails.data?.body[0]?.SecondarySourceId}
          editOffer={editOffer}
          setEditOffer={setEditOffer}
          SkillListingId={SkillListing_id}
          source={chatDetails.data?.body[0]?.SourceTypeId}
          data={props?.data ? props?.data : chatDetails.data?.body[0]}
          setOfferLoading={setOfferLoading}
        />
      )}
      <div style={{ width: "22rem" }}>
        <div
          style={{
            backgroundColor:
              props.status == "Accepted"
                ? "#e7f3eb"
                : props.status == "Offer Declined" ||
                  props.status == "Interview Cancelled" ||
                  props.status == "Candidate Cancelled" ||
                  props.status == "Candidate Terminated" ||
                  props.status == "Declined Bid"
                ? "#fff2f2"
                : props.htmlValue == true
                ? "#f2f2f2"
                : "#e7f3eb",
            padding: "3%",
            width: "100%",
            wordWrap: "break-word",
          }}
        >
          {props.htmlValue == false ? (
            props.children
          ) : (
            <>
              <HyperlinkParagraph text={props.children} />
              {/* <div dangerouslySetInnerHTML={{ __html:  }}></div> */}
              {props.attachments?.length > 0 &&
                props.attachments.map((files, index) => {
                  return (
                    //     <Row key={files?.FileName ?? files?.fileName} className="offer-card-attachmentdiv">
                    //   <FileDownloader {...files} />
                    // </Row>
                    <AttachmentContainer
                    key={index}
                      fileName={files.FileName}
                      filePath={files.FilePath}
                    />
                  );
                })}
            </>
          )}

          <div
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              marginTop: "3%",
              color: "#b4b4b4",
              fontSize: "14px",
              marginRight: "1%",
            }}
          >
            {userProfile?.AccountId == props?.data?.SenderProfileId && props?.data?.ReadAt ? (
              <RiCheckDoubleLine className="double-check-icon" />
            ) : null}
            {moment(props.Created).format("h:m A")}
          </div>
        </div>

        {props.btns && props.status == "Proposed Interview" ? ( //props.status == "Proposed Interview"
         data?.InterviewCard?.InterviewStatuses?.InterviewStatusName !='Accepted' && (
            <div className="chat-card-btns">
              <Button
                className={
                  bidStatus.includes("Interview Cancelled")
                    ? "btns-two-disabled"
                    : "btns"
                }
                onClick={editInterview}
                disabled={disableHandler()}
              >
                {interviewLoading == "Edit-Loading" ? (
                  <LoadingOutlined />
                ) : (
                  "Reschedule"
                )}
              </Button>
              <Button
                className={
                  bidStatus.includes("Interview Cancelled")
                    ? "btns-two-disabled"
                    : "btns"
                }
                onClick={() => RejectCandidate("interview cancelled")}
                disabled={disableHandler()}
              >
                {interviewLoading == "Cancel-parent" ? (
                  <LoadingOutlined />
                ) : (
                  "Cancel"
                )}
              </Button>
            </div>
          )
        ) : props.status == "Scheduled Interview" ? (
          <div className="chat-card-btns">
            <Button
              className={
                bidStatus.includes("Share your feedBack") ||
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Offer Pending")
                  ? "btns-two-disabled"
                  : "btns"
              }
              onClick={reScheduleInterview}
              // disabled={bidStatus.includes("Share your feedBack")}
              disabled={
                bidStatus.includes("Share your feedBack") ||
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Offer Pending")
              }
            >
              Reschedule
            </Button>
            <Button
              onClick={() => RejectCandidate("interview cancelled")}
              // disabled={bidStatus.includes("Share your feedBack")}
              className={
                bidStatus.includes("Share your feedBack") ||
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Offer Pending")
                  ? "btns-two-disabled"
                  : "btns"
              }
              disabled={
                bidStatus.includes("Share your feedBack") ||
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Offer Pending")
              }
            >
              Cancel
            </Button>
          </div>
        ) : props.status == "On Billing" ? (
          <div>
            <Row className="chat-card-btns">
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                    ? // || bidStatus.includes("Rating")
                      "btns-two-disabled"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                  // || bidStatus.includes("Rating")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Off Billing",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "off-billing",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "off-billing" && !bidStatus.includes("Off Billing") ? (
                  <LoadingOutlined />
                ) : (
                  "Move to off billing"
                )}
              </Button>
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                    ? // || bidStatus.includes("Rating")
                      "btns-two-disabled"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                  // || bidStatus.includes("Rating")
                }
                onClick={() => handleExtendContract()}
              >
                Extend contract
              </Button>
              <BillingExtendModal
                visible={extendBilling}
                setVisible={setExtendBilling}
                onClose={() => setExtendBilling(false)}
                desired_rate={props?.data?.OfferCard?.Rate} //rate
                bidId={props?.data?.OfferCard?.BidId} //bidid
                skillListingId={props?.data?.SourceId} //spourceid
                receivedId={props?.data?.OfferCard?.BidId}
                source={props?.data?.SourceTypeId}
                gapExist={gapExist}
              />
            </Row>
            <div className="chat-three-btns">
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                    ? // || bidStatus.includes("Rating")
                      "btns-disable"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                  // || bidStatus.includes("Rating")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Cancelled",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "cancel",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "cancel" ? (
                  <LoadingOutlined />
                ) : (
                  "Cancel contract" 
                )}
              </Button>
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                    ? // || bidStatus.includes("Rating")
                      "btns-disable"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("Billing Extended") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                  // || bidStatus.includes("Rating")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Terminated",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "Terminated",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "Terminated" ? (
                  <LoadingOutlined />
                ) : (
                  "Terminate candidate"
                )}
              </Button>
              <Button
                className={
                  // bidStatus.includes("Candidate Cancelled") ||
                  // bidStatus.includes("Candidate Terminated") ||
                  bidStatus.includes("Rating") &&
                  props?.data?.Ratings?.ConsultantRating != null
                    ? "btns-disable"
                    : "btns"
                }
                disabled={
                  // bidStatus.includes("Candidate Cancelled") ||
                  // bidStatus.includes("Candidate Terminated") ||
                  bidStatus.includes("Rating") &&
                  props?.data?.Ratings?.ConsultantRating != null
                }
                onClick={ratingHandler}
              >
                Rate the candidate
              </Button>
            </div>
          </div>
        ) : props.status == "Billing Extended" ? (
          <div>
            <Row className="chat-card-btns">
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                    bidStatus.includes("On  Billing") ||
                    bidStatus.includes("Candidate Cancelled") ||
                    bidStatus.includes("Candidate Terminated")
                    ?
                    "btns-two-disabled"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Off Billing",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "off-billing",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "off-billing" ? (
                  <LoadingOutlined />
                ) : (
                  "Move to off billing"
                )}
              </Button>
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                    bidStatus.includes("On  Billing") ||
                    bidStatus.includes("Candidate Cancelled") ||
                    bidStatus.includes("Candidate Terminated")
                    ? 
                    "btns-two-disabled"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                }
                onClick={() => handleExtendContract()}
              >
                Extend contract
              </Button>
              <BillingExtendModal
                visible={extendBilling}
                setVisible={setExtendBilling}
                onClose={() => setExtendBilling(false)}
                desired_rate={props?.data?.OfferCard?.Rate} //rate
                bidId={props?.data?.OfferCard?.BidId} //bidid
                skillListingId={props?.data?.SourceId} //spourceid
                receivedId={props?.data?.OfferCard?.BidId}
                source={props?.data?.SourceTypeId}
                gapExist={gapExist}
              />
            </Row>
            <div className="chat-three-btns">
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                    bidStatus.includes("On  Billing") ||
                    bidStatus.includes("Candidate Cancelled") ||
                    bidStatus.includes("Candidate Terminated")
                    ?
                    "btns-disable"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Cancelled",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "cancel",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "cancel" ? (
                  <LoadingOutlined />
                ) : (
                  "Cancel contract" 
                )}
              </Button>
              <Button
                className={
                  bidStatus.includes("Off Billing") ||
                    bidStatus.includes("On  Billing") ||
                    bidStatus.includes("Candidate Cancelled") ||
                    bidStatus.includes("Candidate Terminated")
                    ?
                    "btns-disable"
                    : "btns"
                }
                disabled={
                  bidStatus.includes("Off Billing") ||
                  bidStatus.includes("On  Billing") ||
                  bidStatus.includes("Candidate Cancelled") ||
                  bidStatus.includes("Candidate Terminated")
                }
                onClick={() =>
                  dispatch(
                    editJobOffer(
                      {
                        Status: "Terminated",
                        BidType: source == 1 ? "Bid" : "Proposal",
                        loading: "Terminated",
                      },
                      { id: data?.OfferCard?.BidId }
                    )
                  )
                }
              >
                {editResponse?.editOfferLoading === "Terminated" ? (
                  <LoadingOutlined />
                ) : (
                  "Terminate candidate"
                )}
              </Button>
              <Button
                className={
                  (bidStatus.includes("Rating") &&
                    props?.data?.Ratings?.ConsultantRating != null)
                    ? "btns-disable"
                    : "btns"
                }
                disabled={
                  (bidStatus.includes("Rating") &&
                    props?.data?.Ratings?.ConsultantRating != null)
                }
                onClick={ratingHandler}
              >
                Rate the candidate
              </Button>
            </div>
          </div>
        ) : (
          props.status == "Off Billing" && (
            <div className="chat-three-btns">
              <Button
                disabled={
                  // bidStatus.includes("Candidate Cancelled") ||
                  // bidStatus.includes("Candidate Terminated") ||
                  bidStatus.includes("Rating") &&
                  props?.data?.Ratings?.ConsultantRating != null
                }
                className="btns"
                onClick={ratingHandler}
              >
                Rate the candidate
              </Button>
            </div>
          )
        )}

        {props.threebtns && (
          <div className="chat-three-btns">
            <Button
              className={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Declined")
                  ? "btns-disable"
                  : "btns"
              }
              onClick={scheduleInterview}
              disabled={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Declined") ||
                createInterviewLoading ||
                interviewLoading
              }
            >
              {createInterviewLoading || interviewLoading ? (
                <LoadingOutlined />
              ) : (
                "Schedule an interview"
              )}
            </Button>
            <Button
              className={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Offer Declined")
                  ? "btns-disable"
                  : "btns"
              }
              onClick={() => MakeOffer("post")}
              disabled={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Offer Declined") ||
                editResponse?.makeLoading
              }
            >
              {(editResponse?.makeLoading || offerLoading) && !bidStatus.includes("Offer Pending") ? (
                <LoadingOutlined />
              ) : (
                "Make an offer"
              )}
            </Button>
            <Button
              className={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Declined")
                  ? "btns-disable"
                  : "btns"
              }
              onClick={() => RejectCandidate("rejected")}
              disabled={
                bidStatus.includes("Proposed Interview") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                bidStatus.includes("Offer Declined") ||
                updateBidLoading
              }
            >
              {(updateBidLoading && rejectCandidate) || (updateProposalLoading && rejectCandidate) ? (
                <LoadingOutlined />
              ) : (
                "Decline candidate"
              )}
            </Button>
          </div>
        )}
        {props.status == "Share your feedBack" && (
          <div className="chat-three-btns">
            <Button
              className={
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid")
                  ? "btns-disable"
                  : "btns"
              }
              onClick={() => MakeOffer("post")}
              disabled={
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                editResponse?.makeLoading
              }
            >
              {(editResponse?.makeLoading || offerLoading) && !bidStatus.includes("Offer Pending")  ? (
                <LoadingOutlined />
              ) : (
                "Make an offer"
              )}
            </Button>
            <Button
              className={
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid")
                  ? "btns-disable"
                  : "btns"
              }
              onClick={() => RejectCandidate("rejected")}
              disabled={
                bidStatus.includes("Offer Declined") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Pending") ||
                bidStatus.includes("Declined Bid") ||
                updateBidLoading
              }
            >
              {updateBidLoading ? <LoadingOutlined /> : "Decline candidate"}
            </Button>
          </div>
        )}
        {props.ratings &&
        props.status == "Rating" &&
        props?.data?.SenderUser?.AccountId == userProfile?.AccountId ? (
          <div className="onBilling-card-btns">
            {/* <button className="edit-ratings"  onClick={editRatingHandler} >Edit Rating</button> */}
            <Button
              className="delete-ratings"
              // onClick={DeleteRatingHandler}
              onClick={() => {
                moment(props.data?.Created).add(14, "days") > moment()
                  ? editRatingHandler()
                  : DeleteRatingHandler();
              }}
            >
              {moment(props.data?.Created).add(14, "days") > moment()
                ? "Edit rating"
                : "Delete rating"}
            </Button>
          </div>
        ) : null}
        {props.status === "Offer Pending" && (
          <div className="chat-card-btns">
            <Button
              className={
                bidStatus.includes("Offer Accepted") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Declined")
                  ? "edit-btn-disabled"
                  : "edit-btn"
              }
              onClick={() => MakeOffer("edit")}
              disabled={
                bidStatus.includes("Offer Accepted") ||
                bidStatus.includes("Interview Cancelled") ||
                bidStatus.includes("Offer Declined")
              }
            >
              {editResponse?.editOfferLoading == "Edit-offer" ? (
                <LoadingOutlined />
              ) : (
                "Edit offer"
              )}
            </Button>
          </div>
        )}
        {/* Candidate end reschedule buttons*********************** */}
        {props.status === "Offer Accepted" && (
          <div className="chat-three-btns">
            {userProfile?.Professions?.ProfessionCode == "HC" && (
              <Button
                className="btns"
                onClick={() => {
                  history.push({
                    pathname: "/resume-3d",
                    state: {
                      // candidateid: 68599,
                      candidateid: OfferCards?.UserId,
                      fromChat: true,
                      conversationId: chatDetails[0]?.ConversationId,
                    },
                  });
                }}
              >
                Review credentials
              </Button>
            )}
            <Button
              className={bidStatus.includes("Hired")||bidStatus.includes("Interview Cancelled") ? "btns-disable" : "btns"}
              disabled={bidStatus.includes("Hired")||bidStatus.includes("Interview Cancelled")}
              onClick={() => {
                dispatch(
                  editJobOffer(
                    {
                      Status: "Hired",
                      BidType: source === 1 ? "Bid" : "Proposal",
                      loading: "Hired",
                    },
                    { id: OfferCards?.BidId }
                  )
                );
              }}
            >
              {editResponse?.editOfferLoading === "Hired" ? (
                <LoadingOutlined />
              ) : (
                "Move to hired"
              )}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};
export default CardParent;
